<script>
	import { onMount } from "svelte";
	import { uiText } from "../lib/uiText.js";

	export let lang = bg;

	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));

	let inapp = true;

	$: document.body.classList[inapp ? "add" : "remove"]("standalone-noscroll");

	onMount(async () => {
		let ua = navigator.userAgent || navigator.vendor || window.opera;

		inapp =
			ua.indexOf("FBAN") > -1 ||
			ua.indexOf("FBAV") > -1 ||
			ua.indexOf("Instagram") > -1;
		// console.log(ua, inapp);
	});
</script>

{#if inapp}
	<div
		class="standalone obelisk p-4 fixed top-20 bottom-0 left-0 right-0 grid w-full place-content-center bg-blue-200 z-[9] bg-opacity-90"
	>
		<h3 class="mb-4">{ui.global.standalone.title}</h3>
		<p class="spacer">{ui.global.standalone.description}</p>
	</div>
	<!-- {#if lang == "bg"}
		<h4 id="inapp-message">
			Възможно e някои от функциите на системата да не работят коректно. За
			по-добро изживяване, отворете сайта в браузър, използвайки меню бутона
			горе вдясно (<i class="fas fa-ellipsis-h" aria-hidden="true"></i>) от
			Instagram / Facebook или бутона за споделяне долу вдясно от Messenger.
		</h4>
	{:else}
		<h4 id="inapp-message">
			Възможно e някои от функциите на системата да не работят коректно. За
			по-добро изживяване, отворете сайта в браузър, използвайки меню бутона
			горе вдясно (<i class="fas fa-ellipsis-h" aria-hidden="true"></i>) от
			Instagram / Facebook или бутона за споделяне долу вдясно от Messenger.
		</h4>
	{/if} -->
{/if}

<style>
	* {
		text-wrap: balance;
	}
	:global(.standalone p.spacer) {
		transition: margin 0.5s ease-in-out;
	}
	:global(html.show--consent .standalone p.spacer) {
		margin-bottom: 300px;
	}
</style>
